import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { filterUsers } from '../../../../../redux/actions/users'
import { IRootState } from '../../../../../redux/types'

interface IFilter {
  role_id: number
  countries: number[]
  verificationId: null | number
  requestVip: null | number
  filterBy?: any
  header_role_id?: number | null
  subheader_role_id?: number | null
}

export function useUserFilters() {
  const dispatch = useDispatch()

  const { globalCountriesId } = useSelector((state: IRootState) => state.global)
  const { rolehierarchy } = useSelector((state: IRootState) => state.role)

  const [filters, setFilters] = useState<IFilter>({
    role_id: rolehierarchy.length > 0 ? rolehierarchy[0] : 0,
    countries: [],
    verificationId: null,
    requestVip: null
  })
  const [userIds, setUserIds] = useState<number[]>([])

  const status = [
    { id: 0, name: 'Inactivo' },
    { id: 1, name: 'Activo' }
  ]
  const optionsData = [{ data: status, code: 'status', column: 'status' }]

  useEffect(() => {
    setFilters({ ...filters, countries: globalCountriesId })
  }, [globalCountriesId])

  useEffect(() => {
    if (rolehierarchy.length > 0)
      setFilters({
        ...filters,
        role_id: rolehierarchy[0],
        countries: globalCountriesId,
        header_role_id: rolehierarchy[0]
      })
  }, [rolehierarchy])

  useEffect(() => {
    if (filters.role_id !== 0 && filters.countries.length > 0) dispatch(filterUsers(filters))
  }, [filters])

  const applyChangeFilters = ({
    role_id,
    verificationId = null,
    requestVip = null,
    header_role_id,
    subheader_role_id
  }: {
    role_id: number
    verificationId?: null | number
    requestVip?: null | number
    header_role_id: number
    subheader_role_id: number | null
  }) => {
    setFilters({ ...filters, role_id, verificationId, requestVip, header_role_id, subheader_role_id })
  }

  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: <explanation>
  const handleChangeFilter = (role_id: number, verificationId: null | number) => {
    if (verificationId === 4)
      // pendientes VIP
      applyChangeFilters({
        role_id,
        verificationId: null,
        requestVip: 1,
        header_role_id: role_id,
        subheader_role_id: verificationId
      })
    else if (role_id === 4 && (verificationId === 8 || verificationId === 9)) {
      applyChangeFilters({ role_id, verificationId: null, header_role_id: role_id, subheader_role_id: verificationId })
    } else if (role_id === 6) {
      if (verificationId != null)
        applyChangeFilters({ role_id, verificationId, header_role_id: role_id, subheader_role_id: verificationId })
      else applyChangeFilters({ role_id, header_role_id: role_id, subheader_role_id: null })
    } else {
      if (verificationId != null) applyChangeFilters({ role_id: verificationId, header_role_id: verificationId, subheader_role_id: null })
      else applyChangeFilters({ role_id, header_role_id: role_id, subheader_role_id: verificationId })
    }
    setUserIds([])
  }

  const handleClearFilters = () => {
    const options = { contain: 0, menu: [], status: [], brand: [] }
    setFilters({ ...filters, filterBy: options })
  }

  return {
    filters,
    setFilters,
    userIds,
    setUserIds,
    optionsData,
    handleChangeFilter,
    handleClearFilters
  }
}
